import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import companyApi from '@/features/dashboard/company/api/companyApi.ts';
import { companyApiQueryKeys } from '@/features/dashboard/company/api/companyApi.queryKeys.ts';
import CompanySlugDto from '@/features/dashboard/company/types/CompanySlugDto.ts';

const useGetCompanySlug = () => {
  return useQuery(getCompanySlugQueryOptions());
};

export const getCompanySlugQueryOptions =
  (): UseQueryOptions<CompanySlugDto> => ({
    queryKey: companyApiQueryKeys.companySlug(),
    queryFn: () => companyApi.getCompanySlug(),
    staleTime: 1000 * 60 * 60,
  });

export default useGetCompanySlug;
